import React from 'react';
import PropTypes from 'prop-types';
import { NavigationPropType, PromoBlockPropType } from 'propTypes/common';

import { Layout, LayoutBlock } from 'components/Layout';
import Container from 'components/Container';

import StyledContentHtml from 'components/StyledContent/components/StyledContentHtml';
import styles from './styles.module.scss';

const BidTemplate = ({ menu, text, topPromoBlock }) => (
	<Layout {...{ menu, topPromoBlock }}>
		<LayoutBlock gutter="medium">
			<Container width="entity" className={styles.Bid}>
				<StyledContentHtml html={text} />
			</Container>
		</LayoutBlock>
	</Layout>
);

BidTemplate.propTypes = {
	menu: NavigationPropType.isRequired,
	text: PropTypes.string.isRequired,
	topPromoBlock: PromoBlockPropType
};

export default BidTemplate;
